export default {
    company: "Mein Unternehmen",
    noCompany: "Sie sind keinem Unternehmen zugeordnet.",
};
